'use strict';

export default class StripeRedirectCtrl {
  constructor($location, $state, StripeSvc, LoaderSvc, ToastrSvc) {
    var queryParams = $location.search();
    if(queryParams.error || !queryParams.code) {
      ToastrSvc.error('Authentication Error');
      $state.go('me');
    } else {
      var code = queryParams.code;
      var state = queryParams.state; // group_id

      StripeSvc.connectStripeGroup(code, state).then(function() {
        LoaderSvc.stopSuccess('Stripe Setup Success');
        $state.go('me');
      })
        .catch(function onError(err) {
          console.error('Stripe redirect error:', err);
          LoaderSvc.stopError('Authentication Error');
          $state.go('me');
        });
    }
  }
}

StripeRedirectCtrl.$inject = [
  '$stateParams',
  '$state',
  'LoaderSvc',
  'StripeSvc'
];
